import { defineMessage } from 'services/localization';

export const messages = {
    uploadButtonText: defineMessage('bulk_upload'),
    description: defineMessage('automatically_import_te_nto_approvalmax_in_bulk'),
};
